import AllComponentsContainer from '../Components/FillingForrmComponents/AllComponentsContainer';
import Header from '../Components/Header';
import DesignFirst from './Designes  FOLDER/DesignFirst';
import DesignThird from './Designes  FOLDER/DesignThird';
import DesignSecond from './Designes  FOLDER/DesignSecond';
import  {useState } from 'react';
import ChooseYourDesign from './Designes  FOLDER/Designsecond components/ChooseYourDesign'; 
import './ResumeHome.css';
import {  Routes, Route } from 'react-router-dom';
import LoginPage from './Login and Sign UP/LoginPage.js';
import SignUpPage from './Login and Sign UP/SignUpPage';
import UserLogInPage from '../LogInComponents/UserLogInPage';
import Footer from '../HomeContents/Footer';
import HomeShowContent from '../HomeContents/HomeShowContent';
import ForgotPassword from '../LogInComponents/ForgotPassword';   
import BottomBar from '../HomeContents/BottomBar';
import SeeDesigns from './Designes  FOLDER/Designsecond components/SeeDesigns';
import ContactUs from '../ContactUs';
import AboutUs from '../AboutUs';
import DesignFourth from './Designes  FOLDER/DesignFourth'; 
import Protect from './Login and Sign UP/Protect';
import ChooseDesForLoggedInUser from './Designes  FOLDER/Designsecond components/ChooseDesForLoggedInUser';
import Registrationdetails from './Registrationdetails';


 
let ResumeHome = (props)=>{
   
    // ******************USER DATA PERSONAL, ADDRESS, CONTACT FROM LOGGEDIN FROM**********************************************
    let [UsrsData, setusersdata] = useState('');
    
   
    let getalldata =(gotdatafromgetter)=>{
        setusersdata(gotdatafromgetter);
    }

    let [Democontalldata, setDemocontalldata]=useState('');
    
    let democontalldatafun=(Useralldatafromdemo)=>{
        setDemocontalldata(Useralldatafromdemo); 

    }
    let [dashboarddata, setdashboarddata]=useState('');
    let dataofdashboard=(recdataoffinal)=>{
        setdashboarddata(recdataoffinal);

    }


    // Carrier Data
    let [Carrierdata, setCarrierData] = useState('');
    let GetCarreirData =(cardata) => { 
        setCarrierData(cardata);
    }

    //Academic get data function..
    let [AcademicData, SetAcademicData] = useState(['']);
    
    let GetAcademicData = (FinalOfAcaademicData)=>{
        let AcademicArray = [FinalOfAcaademicData, ...AcademicData];
        SetAcademicData(AcademicArray);
    }
     
    //Computer data function...
    let [ComputrData, setComputerData] = useState(['']);
     let GetComputerData = (FinaOfComputerData)=>{
        let ComputerArray = [FinaOfComputerData, ...ComputrData];
        setComputerData(ComputerArray);
        
     }

     //Technical data function.....
     let [TechData, setTechData] = useState(['']);
        let GetTechnicalData = (FinalOfTechnicalData) => {
            let TechArray = [FinalOfTechnicalData, ...TechData];
            setTechData(TechArray);
        }
        

    // imgae data received...
    let  [fimage, setfimage] = useState('');
     let getimagedata = (FinalImage) => {
        setfimage(FinalImage);

     }
     
    // EXPERIENCE DATA RECEIVING..... 
    let [ExperienceData, SetExperienceData] = useState(['']);
    let GetExperienceData = (FinalOfExperienceData)=> {
        let ExperienceArray = [FinalOfExperienceData, ...ExperienceData]; 
        SetExperienceData(ExperienceArray);  
    }

   

    // Get data from passport comp
let [gotpassportdata, setgotpassportdata]=useState('');
let getdatafrompassportcomp=async(recpassportdata)=>{
    // let passarray=[recpassportdata, ...gotpassportdata];
    setgotpassportdata(recpassportdata);
}

// Get data from physical----------------------
let [getphysicaldata, setgetphysicaldata]=useState([]);
let getphysicaldatafunction=(recphysicaldata)=>{
    setgetphysicaldata(recphysicaldata);
}

    





// signup data..... in php mysql data base----and logindata----------------------------------
let [Logindata, setlogindata]= useState(['']);     
let getdatafromlogin=(LoginReceiveddata)=>{
    let loginmainarray = [LoginReceiveddata, ...Logindata];
    setlogindata(loginmainarray);
}
 
  
 
 
 


 
let chooseyourdesigndata=[
    {
        linkk : "../DesignThird",
        Desimage : "https://makeeasyway.in/resumeData/uploads/third.jpg",
        alt : "image",
        Description: "this is first des"

    },
    {
        linkk : "../DesignFirst",
        Desimage : "https://makeeasyway.in/resumeData/uploads/first.jpg",
         alt : "image",
        Description: "This is second des"
    },
    {
        linkk : "../DesignSecond",
        Desimage : "https://makeeasyway.in/resumeData/uploads/second.jpg",
         alt : "image",
        Description: "this is third des"
    },
    {
        linkk : "../DesignFourth",
        Desimage : "https://makeeasyway.in/resumeData/uploads/fourth.jpg",
         alt : "image",
        Description: "This is fourth des"
    }
];


    return(
        <div className='home_cont'> 
            <Header/>
            <Routes>
                <Route path='/' element={<HomeShowContent/>}/> 
                <Route path='forgotpassword' element={<ForgotPassword/>}/>
            </Routes>
            <Routes>
                <Route path='UserLoginPage/*' element={<Protect Component={UserLogInPage} 
                    finaldata={dashboarddata}
                    Getphydata={getphysicaldatafunction} 
                    Getpasspoetdata={getdatafrompassportcomp}   
                    GetExpData = {GetExperienceData} 
                    GetTechnicalData = {GetTechnicalData} 
                    GetComputerData = {GetComputerData} 
                    GetAcademicData = {GetAcademicData} 
                    getdatafromgetter={getalldata}
                    dataforapi  ={gotpassportdata}
                    Successandrerrorfun={props.Successandrerrorfun}
                    />}>
                    <Route path='ChooseDes' element={<ChooseDesForLoggedInUser/>}/>
                    <Route path='Registration' element={<Registrationdetails    
                    />}/>
                    
     
                </Route>
            </Routes>
            
              
            
            {/* <UsersInDataBase database={SignupData}/>   */}
            <Routes>
                <Route path='LoginPage' element={<LoginPage Successandrerrorfun={props.Successandrerrorfun} datafinal={dataofdashboard}  datafromlogin={getdatafromlogin}/>}/>
                <Route path='SignUpPage' element={<SignUpPage Successandrerrorfun={props.Successandrerrorfun}/>}/>
                <Route path='ChooseYourDesign' element={<ChooseYourDesign linkdata={chooseyourdesigndata}/>}/>
                <Route path='AllDes' element={<SeeDesigns linkdata={chooseyourdesigndata}/>}/> 


{/* ********************************************************************************************************** */}

                <Route path='DesignFirst' element={<DesignFirst 
                // for loggedin component form---------------------------------------------
                    UsersPersonlD={UsrsData} 
                 
                // common for both forms--------------------------------------------
                    AcademicData = {AcademicData} 
                    ComputerData = {ComputrData} 
                    TechDataexp = {TechData} 
                    ExperienceData={ExperienceData} 
                    sendphysicaldata={getphysicaldata}  
                    sendpassportdata={gotpassportdata} 
                    // AllData ={ArrayForDesigns} 
                
                
                    // form demo comp form--------------------------------------------------------
                    imagedataexp = {fimage}  
                    Userdata={Democontalldata}
                    carrierdataf={Carrierdata}
             
                />}>        
                </Route>
 
{/* ********************************************************************************************************** */}

                <Route path='/DesignSecond' element={<DesignSecond 
                sendphysicaldata={getphysicaldata}  
                sendpassportdata={gotpassportdata} 
                UsersPersonlD={UsrsData} 
                ExperienceData={ExperienceData} 
                imagedataexp = {fimage} 
                Userdata={Democontalldata}
                AcademicData = {AcademicData} 
                ComputerData = {ComputrData} 
                carrierdataf={Carrierdata}
                TechDataexp = {TechData} />}/>
                <Route path='/DesignFourth' element ={<DesignFourth 
                AcademicData = {AcademicData} 
                ComputerData = {ComputrData} 
                TechDataexp = {TechData} 
                UsersPersonlD={UsrsData} 
                ExperienceData={ExperienceData} 
                sendphysicaldata={getphysicaldata}  
                Userdata={Democontalldata}
                imagedataexp = {fimage} 
                carrierdataf={Carrierdata}
                sendpassportdata={gotpassportdata}/>}/>
                <Route path='/DesignThird' element={<DesignThird 
                sendphysicaldata={getphysicaldata}  
                sendpassportdata={gotpassportdata} 
                UsersPersonlD={UsrsData}  
                ExperienceData={ExperienceData} 
                imagedataexp = {fimage} 
                Userdata={Democontalldata}
                carrierdataf={Carrierdata}
                AcademicData = {AcademicData} 
                ComputerData = {ComputrData} 
                TechDataexp = {TechData} />}/>
                <Route path='contactus' element={<ContactUs/>}/>
                <Route path='AboutUs' element={<AboutUs/>}/>
                <Route path='ChooseYourQualification' element={
                      <AllComponentsContainer 
                        Getphydata={getphysicaldatafunction} 
                        Getpasspoetdata={getdatafrompassportcomp}   
                        GetExpData = {GetExperienceData} 
                        GetTechnicalData = {GetTechnicalData} 
                        GetComputerData = {GetComputerData} 
                        GetAcademicData = {GetAcademicData} 
                        getdatafromgetter={getalldata}
                        getimage={getimagedata}
                        carrierdata={GetCarreirData}
                        getdemocontdatall={democontalldatafun}
                        Successandrerrorfun={props.Successandrerrorfun}
                      
                      
                    />}/> 

                
            </Routes>
            <Footer/>
            <BottomBar/>
           
        </div>
    );

} 
 
export default ResumeHome;